var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgLogoOnly = function SvgLogoOnly(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 42,
    viewBox: "0 0 45 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.225.5 44.5 13.678v13.18l-22.275-13.18V.5Z",
    fill: "url(#paint0_linear_8189_40944)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.225 41.5 44.5 28.454V15.41L22.225 28.454V41.5Z",
    fill: "url(#paint1_linear_8189_40944)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.225.5.5 13.678v13.18l21.725-13.18V.5Z",
    fill: "url(#paint2_linear_8189_40944)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.225 41.5.5 28.454V15.41l21.725 13.045V41.5Z",
    fill: "url(#paint3_linear_8189_40944)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8189_40944",
    x1: 82.02,
    y1: 20.886,
    x2: -26.482,
    y2: 20.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0A875"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8189_40944",
    x1: 22.5,
    y1: 41.5,
    x2: 28.95,
    y2: -37.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4B4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8189_40944",
    x1: 44.772,
    y1: 8.905,
    x2: 10.672,
    y2: 44.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0A875"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8189_40944",
    x1: 11.363,
    y1: 41.5,
    x2: 11.363,
    y2: 15.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333232"
  })))));
};
export default SvgLogoOnly;